import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import cssClasses from "./FOSList.module.css";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import DropDown from "../../Subcomponents/DropDown";
import SearchBar from "../../Subcomponents/Search";
import UserCard from "./../../Subcomponents/userCard/UserCard";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import Dot from "../Icons/Dot";
import InfiniteScroll from "react-infinite-scroll-component";
//Tabs
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import debounce from "lodash.debounce";

//SERVICE
import {
  getFos,
  updateStatus,
  insertFoSLogs,
  getCpContactPersonId,
  getTotalLeadsCountOfFos,
  getSiteVisitCountOfFos,
  getAllotmentCountOfFos,
  getPreviousCp,
} from "../../Services/FOSList";
import { offlineToast } from "../../Services/Toast";
import { Network } from "@capacitor/network";
import {
  setStoredPendingFos,
  getStoredPendingFos,
  getStoredAcceptedFos,
  setStoredAcceptedFos,
  setStoredRejectedFos,
  getStoredRejectedFos,
  setStoredReassignFos,
  getStoredReassignFos,
  setCountPendingFos,
  getCountPendingFos,
  getCountRejectedFos,
  setCountRejectedFos,
  getCountAcceptedFos,
  setCountAcceptedFos,
  setCountReassignedFos,
  getCountReassignedFos,
} from "../../Services/StoredData";

//MODALS
import RejectReason from "../../Modals/RejectReason/RejectReason";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { handleErrors } from "../../Services/LoginService";
// Icons
import EmptyListIcon from "../../Assets/Images/EmptyDataIcons/MaskGroup2.svg";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { supabase } from "../../supabaseClient";
const useStyles = makeStyles((theme) => ({}));

export default function FosList() {
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("Latest First");
  const [search, setSearch] = useState("");
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [tabs, setTab] = useState([
    "Pending",
    "Accepted",
    "Rejected",
    "Reassign",
  ]);
  const [loadingStatus, setLoadingStatus] = useState(0);
  // const [openreassignModal, setOpenReassignModal] = useState(false);
  const scrollRef = useRef(null);
  const [tabValue, setTabValue] = useState(0);
  const [sendTabValue, setSendTabValue] = useState("pending");
  const [rejectResponse, setRejectResponse] = useState(false);
  const [fosId, setFosId] = useState("");
  const [allFos, setAllFos] = useState([]);
  const [fosCount, setFosCount] = useState(0);
  const [openConfirmationAlert, setOpenConfirmationAlert] = useState(false);
  const [fosPresent, setFosPresent] = useState(null);
  const [confirmationMsg, setConfirmationMsg] = useState("");
  const [selectedOldFos, setSelectedOldFos] = useState("");
  useEffect(() => {
    dispatch(action.activeMenu("foslist"));
  }, []);

  useEffect(() => {
    setPageNumber(0);
    setLoadingStatus(0);
    setFosPresent(null);
    setAllFos([]);
    if (document.getElementById("fosScrollableDiv")) {
      document.getElementById("fosScrollableDiv").scrollTop = 0;
    }
    // setTimeout(() => {
    console.log(search);
    Network.getStatus().then((status) => {
      let pendingFos = getStoredPendingFos();
      console.log(pendingFos);
      if (status.connected) {
        if (pendingFos === null) {
          getAllFos(0, search, drpDownSelectedVal, sendTabValue);
        } else {
          setAllFos(pendingFos);
          setFosPresent(true);
        }
      } else {
        offlineToast();
        sessionStorage.clear();
        setFosCount(0);
      }
    });
    // }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log(loggedInUser);
    sessionStorage.clear();
    setFosCount(0);
  }, [loggedInUser])

  const tabChange = (event, newValue) => {
    let tabCurrentValue = "";
    setTabValue(newValue);
    if (newValue === 0) {
      setSendTabValue("pending");
      tabCurrentValue = "pending";
    } else if (newValue === 1) {
      setSendTabValue("approved");
      tabCurrentValue = "approved";
    } else if (newValue === 2) {
      setSendTabValue("rejected");
      tabCurrentValue = "rejected";
    } else if (newValue === 3) {
      setSendTabValue("reassign");
      tabCurrentValue = "reassign";
    }
    setAllFos([]);
    console.log({ tabValue });
    if (search !== "") {
      sessionStorage.clear();
    }

    Network.getStatus().then((status) => {
      if (status.connected) {
        if (newValue === 0) {
          let pendingFos = getStoredPendingFos();
          if (
            pendingFos === null ||
            pendingFos?.length === 0 ||
            search !== ""
          ) {
            getAllFos(0, "", drpDownSelectedVal, tabCurrentValue);
          } else {
            console.log({ pendingFos });
            setFosPresent(true);
            setAllFos(pendingFos);
            setFosCount(getCountPendingFos());
          }
        } else if (newValue === 1) {
          let acceptedFos = getStoredAcceptedFos();
          console.log({ acceptedFos });
          if (
            acceptedFos === null ||
            acceptedFos?.length === 0 ||
            search !== ""
          ) {
            getAllFos(0, "", "Latest First", tabCurrentValue);
          } else {
            setFosPresent(true);
            setAllFos(acceptedFos);
            setFosCount(getCountAcceptedFos());
          }
        } else if (newValue === 2) {
          let rejectedFos = getStoredRejectedFos();
          console.log({ rejectedFos });
          if (
            rejectedFos === null ||
            rejectedFos?.length === 0 ||
            search !== ""
          ) {
            getAllFos(0, "", drpDownSelectedVal, tabCurrentValue);
          } else {
            setFosPresent(true);
            setAllFos(rejectedFos);
            setFosCount(getCountRejectedFos());
          }
        } else if (newValue === 3) {
          let reassignFos = getStoredReassignFos();
          console.log({ reassignFos });
          if (
            reassignFos === null ||
            reassignFos?.length === 0 ||
            search !== ""
          ) {
            getAllFos(0, "", drpDownSelectedVal, tabCurrentValue);
          } else {
            setFosPresent(true);
            setAllFos(reassignFos);
            setFosCount(getCountReassignedFos());
          }
        } else {
          getAllFos(0, "", drpDownSelectedVal, tabCurrentValue);
        }
      } else {
        offlineToast();
        sessionStorage.clear();
        setFosCount(0);
      }
      document.getElementById("input-with-icon-textfield FosSearch").value = "";
      setSearch("");
      setDrpDownSelectedVal("Latest First");
    });
  };

  // async function getAllFos(
  //   _pageNumber,
  //   search,
  //   drpDownSelectedVal,
  //   sendTabValue
  // ) {
  //   console.log(_pageNumber, search, drpDownSelectedVal);
  //   _pageNumber = _pageNumber ? _pageNumber : 0;
  //   Network.getStatus().then((status) => {
  //     if (status.connected) {
  //       console.log('_pageNumber: ', _pageNumber);
  //       presentLoader();
  //       getFos(
  //         loggedInUser?.cpId,
  //         _pageNumber * pageSize,
  //         _pageNumber * pageSize + pageSize - 1,
  //         search,
  //         drpDownSelectedVal,
  //         sendTabValue
  //       )
  //         .then((resp) => {
  //           setFosCount(resp.count);
  //           let fosCount = 0;
  //           if (resp.count > resp.data.length) {
  //             setLoadingStatus(0);
  //             setPageNumber(1);
  //           } else {
  //             setLoadingStatus(-1);
  //             setPageNumber(0);
  //           }
  //           // setAllFos([...resp.data]);
  //           if (resp.data.length > 0) {
  //             setFosPresent(true);
  //             resp.data.forEach((fos) => {
  //               getCountsForFos(fos.fosId, fos.cpId, sendTabValue).then(
  //                 (counts) => {
  //                   fos.totalLeads = counts.leads;
  //                   fos.totalSiteVisits = counts.siteVisit;
  //                   fos.totalAllotments = counts.allotment;
  //                   fos.totalAgreement = counts.agreement;
  //                   fosCount++;
  //                   if (fosCount === resp.data.length) {
  //                     resp.data = resp.data.map((el, index) => ({
  //                       ...el,
  //                       index: index,
  //                       id: el.fosId,
  //                     }));
  //                     if (fos?.previousCps !== null) {
  //                       getPreviousCp(
  //                         fos?.previousCps[fos?.previousCps?.length - 1]
  //                       )
  //                         .then(async (previousCPResp) => {
  //                           dismissLoader();
  //                           console.log("previousCP", previousCPResp);
  //                           resp.data = resp.data.map((el, index) => ({
  //                             ...el,
  //                             previousCPEName: previousCPResp.cpId.billingName,
  //                           }));
  //                           console.log("resp", resp.data);
  //                           setAllFos([...resp.data]);
  //                           console.log({ sendTabValue });
  //                           if (sendTabValue === "pending") {
  //                             setCountPendingFos(resp.count);
  //                             setStoredPendingFos(resp.data);
  //                           } else if (sendTabValue === "approved") {
  //                             setCountAcceptedFos(resp.count);
  //                             setStoredAcceptedFos(resp.data);
  //                           } else if (sendTabValue === "rejected") {
  //                             setCountRejectedFos(resp.count);
  //                             setStoredRejectedFos(resp.data);
  //                           } else if (sendTabValue === "reassign") {
  //                             setCountReassignedFos(resp.count);
  //                             setStoredReassignFos(resp.data);
  //                           } else {
  //                             setAllFos([...resp.data]);
  //                           }
  //                         })
  //                         .catch((err) => {
  //                           console.log(err);
  //                         });
  //                     } else {
  //                       dismissLoader();
  //                       console.log("resp", resp.data);
  //                       setAllFos([...resp.data]);
  //                       console.log({ sendTabValue });
  //                       if (sendTabValue === "pending") {
  //                         setCountPendingFos(resp.count);
  //                         setStoredPendingFos(resp.data);
  //                       } else if (sendTabValue === "approved") {
  //                         setCountAcceptedFos(resp.count);
  //                         setStoredAcceptedFos(resp.data);
  //                       } else if (sendTabValue === "rejected") {
  //                         setCountRejectedFos(resp.count);
  //                         setStoredRejectedFos(resp.data);
  //                       } else if (sendTabValue === "reassign") {
  //                         setCountReassignedFos(resp.count);
  //                         setStoredReassignFos(resp.data);
  //                       } else {
  //                         setAllFos([...resp.data]);
  //                       }
  //                     }
  //                   }
  //                 }
  //               );
  //             });
  //           } else {
  //             dismissLoader();
  //             if (sendTabValue === "pending") {
  //               setCountPendingFos(resp.count);
  //               setStoredPendingFos(resp.data);
  //             } else if (sendTabValue === "approved") {
  //               setCountAcceptedFos(resp.count);
  //               setStoredAcceptedFos(resp.data);
  //             } else if (sendTabValue === "rejected") {
  //               setCountRejectedFos(resp.count);
  //               setStoredRejectedFos(resp.data);
  //             } else if (sendTabValue === "reassign") {
  //               setCountReassignedFos(resp.count);
  //               setStoredReassignFos(resp.data);
  //             } else {
  //               setAllFos([...resp.data]);
  //             }
  //             setFosPresent(false);
  //           }
  //         })
  //         .catch((err) => {
  //           dismissLoader();
  //           console.log(err);
  //           handleErrors(err, "getFos");
  //         });
  //       setLoadingStatus(0);
  //     } else {
  //       offlineToast();
  //       sessionStorage.clear();
  //       setFosCount(0);
  //     }
  //   });
  // }
  async function getAllFos(
    _pageNumber,
    search,
    drpDownSelectedVal,
    sendTabValue
  ) {
    console.log(_pageNumber, search, drpDownSelectedVal);
    _pageNumber = _pageNumber ? _pageNumber : 0;
    Network.getStatus().then((status) => {
      if (status.connected) {
        console.log('_pageNumber: ', _pageNumber);
        presentLoader();
        getFos(
          loggedInUser?.cpId,
          _pageNumber * pageSize,
          _pageNumber * pageSize + pageSize - 1,
          search,
          drpDownSelectedVal,
          sendTabValue
        )
          .then((resp) => {
            setFosCount(resp.count);
            let fosCount = 0;
            if (resp.count > resp.data.length) {
              setLoadingStatus(0);
              setPageNumber(1);
            } else {
              setLoadingStatus(-1);
              setPageNumber(0);
            }
            // setAllFos([...resp.data]);
            if (resp.data.length > 0) {
              setFosPresent(true);
              resp.data.forEach((fos) => {
                getCountsForFos(fos.fosId, fos.cpId, sendTabValue).then(
                  (counts) => {
                    fos.totalLeads = counts.leads;
                    fos.totalSiteVisits = counts.siteVisit;
                    fos.totalAllotments = counts.allotment;
                    fos.totalAgreement = counts.agreement;
                    fosCount++;
                    if (fosCount === resp.data.length) {
                      resp.data = resp.data.map((el, index) => ({
                        ...el,
                        index: index,
                        id: el.fosId,
                      }));
                      if (fos?.previousCps && fos.previousCps.length > 0) {
                       const lastCpId = fos.previousCps[fos.previousCps.length - 1];
                        console.log("lastCpId----------->", lastCpId)
                        // getPreviousCp(
                        //   fos?.previousCps[fos?.previousCps?.length - 1]
                        // )
                        getPreviousCp(lastCpId)
                          .then(async (previousCPResp) => {
                            dismissLoader();
                            console.log("previousCP", previousCPResp);
                            resp.data = resp.data.map((el, index) => ({
                              ...el,
                              previousCPEName: previousCPResp.cpId.billingName,
                            }));
                            console.log("resp", resp.data);
                            setAllFos([...resp.data]);
                            console.log({ sendTabValue });
                            if (sendTabValue === "pending") {
                              setCountPendingFos(resp.count);
                              setStoredPendingFos(resp.data);
                            } else if (sendTabValue === "approved") {
                              setCountAcceptedFos(resp.count);
                              setStoredAcceptedFos(resp.data);
                            } else if (sendTabValue === "rejected") {
                              setCountRejectedFos(resp.count);
                              setStoredRejectedFos(resp.data);
                            } else if (sendTabValue === "reassign") {
                              setCountReassignedFos(resp.count);
                              setStoredReassignFos(resp.data);
                            } else {
                              setAllFos([...resp.data]);
                            }
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      } else {
                        dismissLoader();
                        console.log("resp", resp.data);
                        setAllFos([...resp.data]);
                        console.log({ sendTabValue });
                        if (sendTabValue === "pending") {
                          setCountPendingFos(resp.count);
                          setStoredPendingFos(resp.data);
                        } else if (sendTabValue === "approved") {
                          setCountAcceptedFos(resp.count);
                          setStoredAcceptedFos(resp.data);
                        } else if (sendTabValue === "rejected") {
                          setCountRejectedFos(resp.count);
                          setStoredRejectedFos(resp.data);
                        } else if (sendTabValue === "reassign") {
                          setCountReassignedFos(resp.count);
                          setStoredReassignFos(resp.data);
                        } else {
                          setAllFos([...resp.data]);
                        }
                      }
                    }
                  }
                );
              });
            } else {
              dismissLoader();
              if (sendTabValue === "pending") {
                setCountPendingFos(resp.count);
                setStoredPendingFos(resp.data);
              } else if (sendTabValue === "approved") {
                setCountAcceptedFos(resp.count);
                setStoredAcceptedFos(resp.data);
              } else if (sendTabValue === "rejected") {
                setCountRejectedFos(resp.count);
                setStoredRejectedFos(resp.data);
              } else if (sendTabValue === "reassign") {
                setCountReassignedFos(resp.count);
                setStoredReassignFos(resp.data);
              } else {
                setAllFos([...resp.data]);
              }
              setFosPresent(false);
            }
          })
          .catch((err) => {
            dismissLoader();
            console.log(err);
            handleErrors(err, "getFos");
          });
        setLoadingStatus(0);
      } else {
        offlineToast();
        sessionStorage.clear();
        setFosCount(0);
      }
    });
  }
  
  async function getCountsForFos(fosId, cpId, sendTabValue) {
    console.log(sendTabValue);
    let counts = { leads: 0, siteVisit: 0, allotment: 0, agreement: 0 };
    counts.leads = await getTotalLeadsCountOfFos(
      fosId,
      cpId,
      sendTabValue,
      loggedInUser.cpId
    );
    counts.siteVisit = await getSiteVisitCountOfFos(fosId, cpId);
    counts.allotment = await getAllotmentCountOfFos(fosId, cpId).then((resp) => {
      console.log('allotment', resp)
      return resp[0].count
    });
    console.log('allotmentCount', counts.allotment);
    // counts.agreement = await getAgreementCountOfFos(fosId);
    return counts;
  }

  // function getMoreData() {
  //   console.log("pageNumber", pageNumber);
  //   console.log("loadingStatus =>", loadingStatus);
  //   if (loadingStatus !== 0) return;
  //   setLoadingStatus(1);
  //   Network.getStatus().then((status) => {
  //     if (status.connected) {
  //       presentLoader();
  //       getFos(
  //         loggedInUser.cpId,
  //         pageNumber * pageSize,
  //         pageNumber * pageSize + pageSize - 1,
  //         search,
  //         drpDownSelectedVal,
  //         sendTabValue
  //       )
  //         .then((resp) => {
  //           dismissLoader();
  //           console.log(resp);
  //           if (resp.count > resp.data.length + allFos.length) {
  //             setLoadingStatus(0);
  //             setPageNumber(pageNumber + 1);
  //           } else {
  //             setLoadingStatus(-1);
  //             setPageNumber(0);
  //           }
  //           setFosCount(resp.count);
  //           let fosCount = 0;
  //           // setAllFos((pre) => [...pre, ...resp.data]);
  //           if (resp.data.length > 0) {
  //             resp.data.forEach((fos) => {
  //               getCountsForFos(fos.fosId, fos.cpId, sendTabValue).then((counts) => {
  //                 fos.totalLeads = counts.leads;
  //                 fos.totalSiteVisits = counts.siteVisit;
  //                 fos.totalAllotments = counts.allotment;
  //                 fos.totalAgreement = counts.agreement;
  //                 fosCount++;
  //                 if (fosCount === resp.data.length) {
  //                   resp.data = resp.data.map((el, index) => ({
  //                     ...el,
  //                     index: index,
  //                     id: el.fosId,
  //                   }));
  //                   if (fos.previousCps !== null) {
  //                     getPreviousCp(
  //                       fos?.previousCps[fos?.previousCps.length - 1]
  //                     )
  //                       .then(async (previousCPResp) => {
  //                         dismissLoader();
  //                         console.log("previousCP", previousCPResp);
  //                         resp.data = resp.data.map((el, index) => ({
  //                           ...el,
  //                           previousCPEName: previousCPResp.cpId.billingName,
  //                         }));
  //                         console.log("resp", resp.data);
  //                         // setAllFos((pre) => [...pre, ...resp.data]);
  //                         // setAllFos([...resp.data]);
  //                         console.log({ sendTabValue });
  //                         if (sendTabValue === "pending") {
  //                           setStoredPendingFos([...allFos, ...resp.data]);
  //                         } else if (sendTabValue === "approved") {
  //                           setStoredAcceptedFos([...allFos, ...resp.data]);
  //                         } else if (sendTabValue === "rejected") {
  //                           setStoredRejectedFos([...allFos, ...resp.data]);
  //                         } else if (sendTabValue === "reassign") {
  //                           setStoredReassignFos(resp.data);
  //                           // } else {
  //                           //   setAllFos((pre) => [...pre, ...resp.data]);
  //                         }
  //                         setAllFos((pre) => [...pre, ...resp.data]);
  //                       })
  //                       .catch((err) => {
  //                         console.log(err);
  //                       });
  //                   } else {
  //                     if (sendTabValue === "pending") {
  //                       setStoredPendingFos([...allFos, ...resp.data]);
  //                     } else if (sendTabValue === "approved") {
  //                       setStoredAcceptedFos([...allFos, ...resp.data]);
  //                     } else if (sendTabValue === "rejected") {
  //                       setStoredRejectedFos([...allFos, ...resp.data]);
  //                     } else if (sendTabValue === "reassign") {
  //                       setStoredReassignFos(resp.data);
  //                       // } else {
  //                       //   setAllFos((pre) => [...pre, ...resp.data]);
  //                     }
  //                     setAllFos((pre) => [...pre, ...resp.data]);
  //                   }
  //                 }
  //               });
  //             });
  //           } else {
  //             dismissLoader();
  //             setAllFos((pre) => [...pre, ...resp.data]);
  //           }
  //         })
  //         .catch((err) => {
  //           dismissLoader();
  //           console.log(err);

  //           handleErrors(err, "scroll-get-Fos");
  //         });
  //       setLoadingStatus(0);
  //     } else {
  //       offlineToast();
  //       sessionStorage.clear();
  //       setFosCount(0);
  //     }
  //   });
  // }
  function getMoreData() {
    console.log("pageNumber", pageNumber);
    console.log("loadingStatus =>", loadingStatus);
    if (loadingStatus !== 0) return;
    setLoadingStatus(1);
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getFos(
          loggedInUser.cpId,
          pageNumber * pageSize,
          pageNumber * pageSize + pageSize - 1,
          search,
          drpDownSelectedVal,
          sendTabValue
        )
          .then((resp) => {
            dismissLoader();
            console.log(resp);
            if (resp.count > resp.data.length + allFos.length) {
              setLoadingStatus(0);
              setPageNumber(pageNumber + 1);
            } else {
              setLoadingStatus(-1);
              setPageNumber(0);
            }
            setFosCount(resp.count);
            let fosCount = 0;
            // setAllFos((pre) => [...pre, ...resp.data]);
            if (resp.data.length > 0) {
              resp.data.forEach((fos) => {
                getCountsForFos(fos.fosId, fos.cpId, sendTabValue).then((counts) => {
                  fos.totalLeads = counts.leads;
                  fos.totalSiteVisits = counts.siteVisit;
                  fos.totalAllotments = counts.allotment;
                  fos.totalAgreement = counts.agreement;
                  fosCount++;
                  if (fosCount === resp.data.length) {
                    resp.data = resp.data.map((el, index) => ({
                      ...el,
                      index: index,
                      id: el.fosId,
                    }));
                    if (fos?.previousCps && fos.previousCps.length > 0) {
                      const lastCpId = fos.previousCps[fos.previousCps.length - 1];
                        console.log("lastCpId----------->", lastCpId)
                      // getPreviousCp(
                      //   fos?.previousCps[fos?.previousCps.length - 1]
                      // )
                      getPreviousCp(lastCpId)
                        .then(async (previousCPResp) => {
                          dismissLoader();
                          console.log("previousCP", previousCPResp);
                          resp.data = resp.data.map((el, index) => ({
                            ...el,
                            previousCPEName: previousCPResp.cpId.billingName,
                          }));
                          console.log("resp", resp.data);
                          // setAllFos((pre) => [...pre, ...resp.data]);
                          // setAllFos([...resp.data]);
                          console.log({ sendTabValue });
                          if (sendTabValue === "pending") {
                            setStoredPendingFos([...allFos, ...resp.data]);
                          } else if (sendTabValue === "approved") {
                            setStoredAcceptedFos([...allFos, ...resp.data]);
                          } else if (sendTabValue === "rejected") {
                            setStoredRejectedFos([...allFos, ...resp.data]);
                          } else if (sendTabValue === "reassign") {
                            setStoredReassignFos(resp.data);
                            // } else {
                            //   setAllFos((pre) => [...pre, ...resp.data]);
                          }
                          setAllFos((pre) => [...pre, ...resp.data]);
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    } else {
                      if (sendTabValue === "pending") {
                        setStoredPendingFos([...allFos, ...resp.data]);
                      } else if (sendTabValue === "approved") {
                        setStoredAcceptedFos([...allFos, ...resp.data]);
                      } else if (sendTabValue === "rejected") {
                        setStoredRejectedFos([...allFos, ...resp.data]);
                      } else if (sendTabValue === "reassign") {
                        setStoredReassignFos(resp.data);
                        // } else {
                        //   setAllFos((pre) => [...pre, ...resp.data]);
                      }
                      setAllFos((pre) => [...pre, ...resp.data]);
                    }
                  }
                });
              });
            } else {
              dismissLoader();
              setAllFos((pre) => [...pre, ...resp.data]);
            }
          })
          .catch((err) => {
            dismissLoader();
            console.log(err);

            handleErrors(err, "scroll-get-Fos");
          });
        setLoadingStatus(0);
      } else {
        offlineToast();
        sessionStorage.clear();
        setFosCount(0);
      }
    });
  }

  function fosRejected(value) {
    if (value) {
      setPageNumber(0);
      setLoadingStatus(0);
      setAllFos([]);
      Network.getStatus().then((status) => {
        if (status.connected) {
          getAllFos(0, search, drpDownSelectedVal, sendTabValue);
          sessionStorage.removeItem("countRejectedFos");
          sessionStorage.removeItem("RejectedFos");
        } else {
          offlineToast();
          sessionStorage.clear();
          setFosCount(0);
        }
      });
    }
  }

  function fosReassign(value) {
    if (value) {
      setPageNumber(0);
      setLoadingStatus(0);
      setAllFos([]);
      Network.getStatus().then((status) => {
        if (status.connected) {
          getAllFos(0, search, drpDownSelectedVal, sendTabValue);
          sessionStorage.removeItem("countReassignFos");
          sessionStorage.removeItem("ReassignFos");
          sessionStorage.removeItem("countRejectedFos");
          sessionStorage.removeItem("RejectedFos");
          console.log("Hiii");
        } else {
          offlineToast();
        }
      });
    }
  }

  function updateFosStatus(fos) {
    console.log("fos: ", fos);
    updateStatus(fos.fosId, "approved")
      .then((res) => {
        console.log(fos.cpId);
        getCpContactPersonId(fos.cpId)
          .then((resp) => {
            console.log(fos.fosId, "approved", resp[0].cpContactPersonId);
            insertFoSLogs(fos.fosId, "approved", resp[0].cpContactPersonId)
              .then((resp) => {
                console.log("insertIntoFosLog:", resp);
                setAllFos([]);
                Network.getStatus().then((status) => {
                  if (status.connected) {
                    getAllFos(0, search, drpDownSelectedVal, sendTabValue);
                    sessionStorage.removeItem("countAcceptedFos");
                    sessionStorage.removeItem("AcceptedFos");
                  } else {
                    offlineToast();
                    sessionStorage.clear();
                    setFosCount(0);
                  }
                });
              })
              .catch((err) => {
                handleErrors("updateFosStatus");
              });
          })
          .catch((err) => {
            handleErrors(err, "update fos status - get cp contact person");
          });
      })
      .catch((err) => {
        handleErrors(err, "update fos status");
      });
  }
  async function reassignFos(fos) {
    console.log(fos);
    presentLoader();
    const { data, error } = await supabase
      .from("Leads")
      .update({ fosId: fos })
      .eq("fosId", selectedOldFos)
      .eq("cpId", loggedInUser.cpId);

    if (data) {
      dismissLoader();
      console.log(data);
      fosReassign(true);
    } else throw error;
  }
  function refreshFos() {
    console.log(sendTabValue);
    if (sendTabValue === "pending") {
      sessionStorage.removeItem("countPendingFos");
      sessionStorage.removeItem("pendingFos");
    } else if (sendTabValue === "approved") {
      sessionStorage.removeItem("countAcceptedFos");
      sessionStorage.removeItem("AcceptedFos");
    } else if (sendTabValue === "rejected") {
      sessionStorage.removeItem("countRejectedFos");
      sessionStorage.removeItem("RejectedFos");
    } else if (sendTabValue === "reassign") {
      sessionStorage.removeItem("countReassignedFos");
      sessionStorage.removeItem("ReassignFos");
    }
    getAllFos(0, search, drpDownSelectedVal, sendTabValue);
  }

  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
    sessionStorage.clear();
    setFosCount(0);
    getAllFos(0, e.target.value, drpDownSelectedVal, sendTabValue);
  }, 800);
  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        sx={[
          {
            fontFamily: "Inter-Medium !important",
            fontStyle: "normal !important",
            fontWeight: "500 !important",
            fontSize: "1.6rem!important",
            lineHeight: "2.4rem!important",
            textTransform: "none !important",
          },
        ]}
      />
    );
  });
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperHeader}>
        <div>
          <div className={cssClasses.headerTitle}>FoS</div>
          <div className={cssClasses.headerSubTitle}>Manage your FoS here.</div>
        </div>
      </div>
      <div className={cssClasses.wrapperTabs}>
        <Tabs
          value={tabValue}
          onChange={tabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Fos Lists"
          sx={[
            {
              borderBottom: "1px solid #EAECF0 !important",
            },
          ]}
        >
          {tabList}
        </Tabs>
      </div>

      <div className={cssClasses.wrapperFilters}>
        <div className={cssClasses.wrapperNameDropDown}>
          <div className={cssClasses.allLeadsTitle}>{fosCount} FoS</div>
          <div className={cssClasses.wrapperDropDown}>
            {/* <div>Filter By</div> */}
            <DropDown
              list={[
                "Name Ascending",
                "Name Descending",
                "Latest First",
                "Oldest First",
              ]}
              selectedValue={drpDownSelectedVal}
              onChangeSelect={(_value) => {
                setDrpDownSelectedVal(_value);
                getAllFos(0, search, _value, sendTabValue);
              }}
              placeHolder={"Select"}
              //style.color is placeHolder's color
              style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
              helperText={""}
            />
          </div>
        </div>
        <div className={cssClasses.wrapperSearchBar}>
          <SearchBar
            id={"FosSearch"}
            placeholder={"Search"}
            // value={search}
            search={debouncedFetchSearchData}
            width="100%"
          />
        </div>
      </div>
      <div
        className={cssClasses.wrapperTable}
        // onScroll={onScroll}
        // ref={scrollRef}
        id="fosScrollableDiv"
      >
        {fosPresent && (
          <InfiniteScroll
            dataLength={allFos?.length}
            next={getMoreData}
            style={{ display: "flex", flexDirection: "column" }} //To put endMessage and loader to the top.
            hasMore={loadingStatus === 0}
            scrollableTarget="fosScrollableDiv"
            // endMessage={
            // <p className={cssClasses.infiniteScrollLoadingText}>
            //   {(AllLeads.length > 5) && <b>Yay! You have seen it all notification</b>}
            // </p>
            // }
            refreshFunction={refreshFos}
            pullDownToRefresh
            pullDownToRefreshThreshold={50}
            pullDownToRefreshContent={
              <h3 style={{ textAlign: "center" }}>
                &#8595; Pull down to refresh
              </h3>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: "center" }}>
                &#8593; Release to refresh
              </h3>
            }
          >
            {allFos &&
              fosPresent &&
              allFos.map((data) => (
                <UserCard
                  data={data}
                  key={data.fosId}
                  acceptFos={() => {
                    updateFosStatus(data);
                  }}
                  rejectFos={() => {
                    setFosId(data.fosId);
                    setRejectResponse(true);
                  }}
                  reassignFos={(fos) => {
                    setOpenConfirmationAlert(true);
                    reassignFos(fos);
                  }}
                  currentCpId={loggedInUser.cpId}
                  tabValue={sendTabValue}
                  setConfirmationMsg={(e) => setConfirmationMsg(e)}
                  setSelectedOldFos={(oldFosId) => setSelectedOldFos(oldFosId)}
                />
              ))}
          </InfiniteScroll>
        )}
        {fosPresent === false && (
          // <div className="noDataMsg">No Leads</div>
          <div className={cssClasses.noDataMsg}>
            <div className={cssClasses.emptyIcon}>
              <img src={EmptyListIcon} alt="No FoS" />
            </div>
            <div className={cssClasses.emptyTitle}>
              No {sendTabValue} FoS found
            </div>
          </div>
        )}
      </div>
      {rejectResponse && (
        <RejectReason
          open={rejectResponse}
          handleClose={() => {
            setRejectResponse(false);
          }}
          loggedInUserId={loggedInUser.id}
          saveResp={fosRejected}
          data={fosId}
        />
      )}
      <ConfirmationAlert
        open={openConfirmationAlert}
        close={() => setOpenConfirmationAlert(false)}
        title={confirmationMsg}
        confirm={() => setOpenConfirmationAlert(false)}
        buttonTitle={"Close"}
      // icon={}
      />
    </div>
  );
}
